import { render } from "./MagazineSliderForm.vue?vue&type=template&id=4345f0d2&scoped=true"
import script from "./MagazineSliderForm.vue?vue&type=script&lang=js"
export * from "./MagazineSliderForm.vue?vue&type=script&lang=js"

import "./MagazineSliderForm.vue?vue&type=style&index=0&id=4345f0d2&scoped=css&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4345f0d2"]])

export default __exports__